module.exports = __webpack_public_path__ + "img/zhinengpipei.ab171775.png";